// Internal Imports
import { get, post } from "../../api/index";
import { API_ENDPOINTS } from "../../constants";

// Destructuring
const { APIS } = API_ENDPOINTS;

export const fetchCrmDetails = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.CRM}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const postCRMConfigData = configData =>
  new Promise((resolve, reject) => {
    post(`${APIS.CRM}`, configData)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const postCRMCallback = params =>
  new Promise((resolve, reject) => {
    post(`${APIS.CRM_CALLBACK}?${params}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const syncCRMUsers = () =>
  new Promise((resolve, reject) => {
    post(`${APIS.CRM_SYNC}/users`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const syncCRMAccounts = () =>
  new Promise((resolve, reject) => {
    post(`${APIS.CRM_SYNC}/accounts`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const syncCRMContacts = () =>
  new Promise((resolve, reject) => {
    post(`${APIS.CRM_SYNC}/contacts`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const syncCRMOppStages = () =>
  new Promise((resolve, reject) => {
    post(`${APIS.CRM_SYNC}/oppstages`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const syncCRMOpportunities = () =>
  new Promise((resolve, reject) => {
    post(`${APIS.CRM_SYNC}/opportunities`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const syncCRMProductFamilies = () =>
  new Promise((resolve, reject) => {
    post(`${APIS.CRM_SYNC}/categories`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const syncCRMProducts = () =>
  new Promise((resolve, reject) => {
    post(`${APIS.CRM_SYNC}/products`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const syncDocSign = configData =>
  new Promise((resolve, reject) => {
    post(`${APIS.SYNC_DOC_SIGN}`, configData)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const fetchRedirectURL = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.GET_REDIRECT_URL}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const disconnectDocuSign = () =>
  new Promise((resolve, reject) => {
    post(`${APIS.DISSCONNECT_DOCU_SIGN}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const fetchZapierKey = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.ZAPIER_KEY}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const fetchZapierKeyForOrg = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.ZAPIER_KEY_BASED_ON_ORG}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });



// WEBPACK FOOTER //
// ./src/actions/IntegrationsActions/IntegrationsServices.js